import { useResourceFormContext } from "src/components/Form/hooks/useResourceFormContext.ts";
import { useErpTranslation } from "src/system/useErpTranslation.ts";

export const useResourceFormTranslation = () => {
  const { action, resource, tab } = useResourceFormContext();
  return useErpTranslation({
    resource,
    type: "form",
    formType: action,
    tab,
  });
};
